import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography, Link } from '@mui/material';
import { PRIMARY_GRADIENT, PRIMARY_GRADIENT_HOVER, TEXT_SECONDARY } from '../colors';

const CONSENT_KEY = 'fp_analytics_consent';

const getInitialConsentState = () => {
  if (typeof window === 'undefined') return 'granted';
  const stored = localStorage.getItem(CONSENT_KEY);
  if (stored === 'granted' || stored === 'denied') return stored;
  return 'pending';
};

export default function ConsentBanner() {
  const [consent, setConsent] = useState(getInitialConsentState);

  useEffect(() => {
    if (consent === 'granted' || consent === 'denied') {
      localStorage.setItem(CONSENT_KEY, consent);
    }
  }, [consent]);

  if (consent === 'granted' || consent === 'denied') return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        // On mobile, position above the BottomNav (which is ~64px tall)
        bottom: { xs: 80, md: 24 },
        left: { xs: 12, md: 'auto' },
        right: { xs: 12, md: 24 },
        zIndex: 1400,
        maxWidth: { xs: 420, md: 320 },
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 3,
          borderRadius: 2,
          background: 'rgba(22, 26, 48, 0.95)',
          border: '1px solid rgba(255,255,255,0.08)',
          color: 'white',
        }}
      >
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
          🍪 We use cookies
        </Typography>
        <Typography variant="body2" sx={{ color: TEXT_SECONDARY, mb: 2 }}>
          We use cookies and similar technologies to improve your experience, analyze site traffic, and personalize content. By clicking "Accept All", you consent to our use of cookies. You can manage your preferences or decline non-essential cookies.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            onClick={() => setConsent('granted')}
            sx={{
              background: PRIMARY_GRADIENT,
              '&:hover': { background: PRIMARY_GRADIENT_HOVER },
            }}
          >
            Accept All
          </Button>
          <Button variant="outlined" onClick={() => setConsent('denied')} sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.3)' }}>
            Reject Non-Essential
          </Button>
          <Link href="/privacy.html" target="_blank" rel="noopener" sx={{ ml: 'auto', alignSelf: 'center', color: 'white', fontWeight: 600 }}>
            Privacy Policy
          </Link>
        </Box>
      </Paper>
    </Box>
  );
}

export const isAnalyticsConsentGranted = () => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(CONSENT_KEY) === 'granted';
};